import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';
import { ITaxonResponse } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class TaxonService extends InsectaServiceBase {
  public getTaxa(name: string, matchType: string, pageNumber: number, pageSize: number): Observable<ITaxonResponse> {
    return this.get<ITaxonResponse>(`/taxon/${name}/${matchType}/${pageNumber}/${pageSize}`, `v1`);
  }
}
